module.exports = "footer{\n  color: white;\n}\n\nfooter a{\n    color: white;\n}\n\nfooter .subfooter {\n  padding-top: 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.css
// module id = ./src/app/footer/footer.component.css
// module chunks = main